<template>
  <dashboard-layout>
    
    <div class="container-fluid">
      <div class="col-md-6">
        <router-link to="/netpay" class="icon text-gray-600">
        <i class="fas fa-arrow-left"></i> Back
        </router-link>
    </div>
      <div class="card shadow mb-4">
        <div class="card-body">
          <div class="col-md-6">
           
           <h6 class="m-0 font-weight-bold text-dark">Bulk Settlement Reprocess</h6><br>
         </div>
            <div class="row">
              <div class="col-md-6">
                <label for="formFileSm" class="form-label">Upload Excel File</label>
                <input class="form-control" id="formFileMd" type="file" @change="handleFileChange" /><br />

            
                <div class="d-flex">
                <button v-if="fileSelected" @click="handleClearTable" class="btn btn-danger btn-icon-split mr-3">
                <span class="icon text-black-600">
                  <i class="fas fa-times"></i> 
                </span>
                <span class="text">Clear Record</span> 
              </button>

              <router-link to="/view-transactions" class="icon text-gray-600">
              <button v-if="fileSelected"  class="btn btn-success btn-icon-split">
                <span class="icon text-white-600">
                  <i class="fas fa-eye"></i> 
                </span>
                <span class="text">View Transactions</span> 
              </button>
            </router-link>
          </div>

              </div>


            </div>
         
        </div>

        <div v-if="showSuccessMessage" class="alert alert-success" role="alert">
            Settlement has been reprocessed Successfully, Please reconfirm again in few minutes
          </div>
          <div v-if="errorMessage" class="alert alert-danger" role="alert">
            Failed to Reprocess please contact the system administrator
          </div>

        <div class="card-body">
          <div class="table-responsive" v-if="excelData.length > 0">
            <table class="table table-bordered" width="10%" cellspacing="10">
              <thead>
                <tr>
                  <th>PaymentDate</th>
                  <th>ReceiptNumber</th>
                  <th>PayerName</th>
                  <th>PaymentReference</th>
                  <th>InvoiceNumber</th>
                  <th>TotalAmount</th>
                  <th>Settlement_Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
             
                <tr v-for="(row, index) in displayedData" :key="index">
                  <td>{{ row[0] }}</td>
                  <td>{{ row[1] }}</td>
                  <td>{{ row[2] }}</td>
                  <td>{{ row[5] }}</td>
                  <td>{{ row[8] }}</td>
                  <td>{{ formatAmount(row[9]) }}</td>
                  <td :style="getSettlementStatusStyle(row[10])">

                    <i v-if="excelData[index].Isloading" class="fas fa-spinner fa-spin" style="color: #333;"></i>

                  
                    <i v-else-if="Isloading === false">{{ row[10] }}</i>
                  
                  </td>
                  <td>
                    <i v-if="excelData[index].Isloading" class="fas fa-spinner fa-spin" style="color: #333;"></i>

              <i v-else-if="row[10] === 'Settled'"
                class="fas fa-check-circle"
                style="color: green;"
                v-b-tooltip.hover title="Successful"> 
              </i>
              <i
                v-else-if="row[10] === 'Reprocessed'"
                class="fas fa-sync-alt"
                style="color: grey;"
                v-b-tooltip.hover title="Reprocessed"
                disabled="true">
              </i>
              <i v-else-if="row[10] === 'Not Settled' && !reprocessed[index]"
                class="fas fa-sync-alt"
                style="color: black;"
                v-b-tooltip.hover title="Reprocess"
                @click="handleReprocess(index, row[5])"> 
            </i>
            <i v-else-if="['Settlement is still Processing', 'Trxn Not Found','Request Timed Out, Please Refresh'].includes(row[10])"
                class="fas fa-times"
                style="color: red;"
                v-b-tooltip.hover title="Not Found"> 
            </i>
            </td>

                </tr>
              </tbody>
            </table>
            <br>
                <div class="text-center">
              <ul class="pagination">
                <li :class="{ 'disabled': pageNumber === 1 }">
                  <a @click="pageNumber > 1 ? pageNumber-- : null">&laquo;</a>
                </li>
                <li v-for="pageNumber in totalPages" :key="pageNumber" :class="{ 'active-page': pageNumber === currentPage }">
                  <a @click="changePage(pageNumber)" class="page-number">{{ pageNumber }}</a>
                </li>
                <li :class="{ 'disabled': currentPage === totalPages }">
                  <a @click="pageNumber < totalPages ? pageNumber++ : null">&raquo;</a>
                </li>
              </ul>
            </div>
          </div>
          <div v-else>
            <table class="table table-bordered table-responsive" width="10%" cellspacing="10">
              <thead>
                <tr>
                  <th>PaymentDate</th>
                  <th>ReceiptNumber</th>
                  <th>PayerName</th>
                  <th>PaymentReference</th>
                  <th>InvoiceNumber</th>
                  <th>TotalAmount</th>
                  <th>Settlement_Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <center>No Record Found</center>
            </table>
            
        </div>
        </div>
      </div>
    </div>
  </dashboard-layout>
</template>



<script>
import * as XLSX from 'xlsx';
import DashboardLayout from '@/components/DashboardLayout.vue';
import axios from 'axios';

let logData; 





export default {
  name: 'bulksettlementreprocess-page',

  components: {
    DashboardLayout,
  
  },

  data() {
    return {
      showSuccessMessage: false,
        errorMessage: '',
      fileSelected: false,
      excelData: [],
      reprocessed: [], 
      currentPage: 1,
      pageSize: 4, 
      Isloading: true,
      rowLoadingStates: [],
    };
  },

  computed: {
    displayedData() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.excelData.slice(start, end);
  },
  totalPages() {
    return Math.ceil(this.excelData.length / this.pageSize);
  },
},


  methods: {

    formatAmount(amount) {
      
      const amountWithDecimals = Number(amount) / 100;

     
      const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      return formatter.format(amountWithDecimals);
    },


    changePage(pageNumber) {
    this.currentPage = pageNumber;
 
  },
    async handleFileChange(event) {
      this.fileSelected = false; 

      const file = event.target.files[0];
      

      if (file && (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel')) {
        const reader = new FileReader();

        reader.onload = async (e) => {
          try {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });

            if (workbook.SheetNames && workbook.SheetNames.length > 2) {
              const firstSheetName = workbook.SheetNames[2];
              const worksheet = workbook.Sheets[firstSheetName];

              const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

              if (jsonData.length > 1) {

                if (jsonData[0][5] !== 'Payment Reference' && jsonData[0][5] !== 'Merchant Reference') {
                
                  this.$toast.open({
                    message: 'Invalid file format. Excel file must have "Payment Reference" or "Merchant Reference" in column F-A.',
                    type: 'warning',
                    duration: 4000,
                  });
                  return;
                }
               
                this.excelData = jsonData.slice(1);
                this.fileSelected = true;

               
                for (let i = 0; i < this.excelData.length; i++) {
                  const merchantRef = this.excelData[i][5];
                

                  try {
                    const token = sessionStorage.getItem('token');
                    const response = await axios.post(this.$config.CHECKSETTELEMTSTATUS_ENDPOINT, {
                      MerchantRef: merchantRef,
                    },
                    {
                    headers: {
                      Authorization: `Bearer ${token}`
                  },
                  });

                 
                  this.excelData[i].push(response.data.response);
                  this.Isloading = false;
                  

                  } catch (error) {
                    console.error('Error fetching settlement status:', error);
                    this.$toast.open({
                      message: 'Error fetching settlement status:', error,
                      type: 'error', 
                      duration: 3000, 
                    });
                                }
                }
              } else {
                console.error('Excel file is empty or has no data rows.');
                this.$toast.open({
                message: 'Excel file is empty or has no data rows.',
                type: 'error', 
                duration: 3000, 
              });
              }
            } else {
              console.error('Excel sheet not found or not enough sheets.');
              this.$toast.open({
            message: 'Invalid Excel Format, Please refer to the Temple for Bulk Upload',
            type: 'warning', 
            duration: 3000, 
          });
            }
          } catch (error) {
            console.error('Error reading Excel file:', error);
            this.$toast.open({
            message: 'Error reading Excel file:', error,
            type: 'error', 
            duration: 3000, 
          });
            
          }
        };

        reader.readAsArrayBuffer(file);
      } else {
        console.error('Invalid file type. Please upload a valid Excel file.');
        this.$toast.open({
        message: 'Invalid file type. Please upload a valid Excel file.',
        type: 'warning', 
        duration: 3000, 
      });
      }
    },

    getSettlementStatusStyle(status) {
      let style = {
         color: 'black'
        
        }; 

      if (status === 'Settled') {
        style.color = 'green';
        style['font-weight'] = 'bold'; 
      } else if (status === 'Not Settled') {
        style.color = 'red';
        style['font-weight'] = 'bold'; 
      }
      else if (status === 'Settlement is still Processing') {
        style.color = 'purple';
        style['font-weight'] = 'bold'; 
      }
      else if (status === 'Reprocessed') {
        style.color = 'orange';
        style['font-weight'] = 'bold'; 
      }

      return style;
    },

    handleClearTable() {

  this.excelData = [];
  

  const fileInput = document.getElementById('formFileMd'); 
  fileInput.value = ''; 
  this.fileSelected = false; 
},

async handleReprocess(index, merchantRef) {
 
         
        const rowRecord = this.excelData[index];
        rowRecord.Isloading = true;

      try {
        const token = sessionStorage.getItem('token');
        const headers = {
          'Authorization': `Bearer ${token}`,
        };
        const response = await axios.post(this.$config.UPDATESETTLEMENT_ENDPOINT, {
          MerchantRef: merchantRef,
        },{headers});


      const totalAmountString = rowRecord[9].toString();
      const addRecordResponse = await axios.post(this.$config.ADDREPROCESSEDRECORD_ENDPOINT, {
      RecordDate: rowRecord[0], 
      Receipt_Number: rowRecord[1],
      Payer_Name: rowRecord[2],
      Payment_Reference: rowRecord[5],
      Invoice_Number: rowRecord[8],
      Total_Amount: totalAmountString
    },{headers});

        if (response.status == 200 && addRecordResponse.status == 200) {
        logData = {
  UserID: sessionStorage.getItem('userId'),
  FName: sessionStorage.getItem('firstName'),
  LName: sessionStorage.getItem('lastName'),
  Email: sessionStorage.getItem('email'),
  Role: sessionStorage.getItem('role'),
  Department: sessionStorage.getItem('department'),
  ActionType: 'Bulk Settlement Reprocess',
  Activity: `Settlement for ${merchantRef} has been reprocessed successfully`,
  Category: 'Netpay',
  Timestamp: new Date().toISOString()
};

const token = sessionStorage.getItem('token');
const headers = {
  'Authorization': `Bearer ${token}`,
};


axios.post(this.$config.ADDACTIVITYLOG_ENDPOINT, logData, { headers })
  .then(response => {
   
    console.log(response);
  })
  .catch(error => {
  
    console.error(error);
    this.$toast.open({
        message: error,
        type: 'error', 
        duration: 3000, 
      });
  });

  this.$toast.open({
        message: `Settlement for ${merchantRef} has been reprocessed successfully`,
        type: 'success', 
        duration: 3000, 
      });
        } else {
        this.$toast.open({
        message: 'Failed to Reprocess please contact the system administrator',
        type: 'error', 
        duration: 3000,
      });
        }
        
        rowRecord.Isloading = false;
      this.excelData[index][10] = 'Reprocessed';

       
        this.reprocessed[index] = true;

        setTimeout(() => {
     this.showSuccessMessage = false;
    }, 2000);
    setTimeout(() => {
     this.errorMessage = false;
    }, 2000);


      } catch (error) {
        console.error('Error during reprocess:', error);
        this.errorMessage = error;
        setTimeout(() => {
     this.errorMessage = false;
    }, 2000);

       
      }

      
    },

  },
};
</script>




<style>
.custom-card {
  margin: 10px;
}

.custom-card-width {
  max-width: 900px;
  margin: 30px auto;
}
</style>